import { GraphQLRequestClient } from '@sitecore-jss/sitecore-jss-nextjs';
import config from 'temp/config';
import { toGraphQLId } from 'lib/utils/string-utils';

type AffiliateQueryResult = {
  affiliate: {
    id: string;
    name: string;
    affiliateId: {
      value: string;
    };
  };
};

const affiliateIdQuery = `
query GetAffiliateIdByItemId($itemId: String) {
  affiliate: item(path: $itemId, language: "en") {
  id
  name
  ... on Affiliate {
      affiliateId {
          value
      }
  }
}
}
`;

export class AffiliateService {
  private graphQLClient: GraphQLRequestClient;

  constructor() {
    this.graphQLClient = this.getGraphQLClient();
  }

  protected getGraphQLClient(): GraphQLRequestClient {
    return new GraphQLRequestClient(config.graphQLEndpoint, {
      apiKey: config.sitecoreApiKey,
    });
  }

  async getAffiliateId(itemId: string) {
    const result = await this.graphQLClient.request<AffiliateQueryResult>(affiliateIdQuery, {
      itemId: toGraphQLId(itemId) ?? 'null',
    });

    return result?.affiliate?.affiliateId?.value ?? '';
  }
}

export const affiliateService = new AffiliateService();
